import React from 'react'
import { Provider } from 'react-redux'
import configStore from './store/configStore'
import ReactDOM from 'react-dom'
import App from './components/App'

const store = configStore()

ReactDOM.render(
  <Provider store={store}>
    <App/>
  </Provider>,
  document.getElementById('root')
)